import { jsxs as s, jsx as n } from "react/jsx-runtime";
import { c } from "../clsx-OuTLNxxd.js";
import { B as l } from "../Badge-U9u-iOJu.js";
import { a as B } from "../Tooltip-B32dr0H7.js";
import '../Comparison.css';const C = "_comparisonContainer_v223z_32", f = "_valuesContainer_v223z_41", u = "_value_v223z_41", $ = "_label_v223z_49", z = "_leftBadge_v223z_59", b = "_rightBadge_v223z_63", N = "_progressBarContainer_v223z_87", w = "_hasMiddleValue_v223z_93", A = "_progressBar_v223z_87", R = "_leftBar_v223z_100", x = "_rightBar_v223z_103", y = "_separatorContainer_v223z_125", M = "_middleBadge_v223z_138", W = "_badgeRightAligned_v223z_151", a = {
  comparisonContainer: C,
  valuesContainer: f,
  value: u,
  label: $,
  leftBadge: z,
  rightBadge: b,
  progressBarContainer: N,
  hasMiddleValue: w,
  progressBar: A,
  leftBar: R,
  rightBar: x,
  separatorContainer: y,
  middleBadge: M,
  badgeRightAligned: W
}, j = (o, t = "Comparison") => {
  const i = o.reduce((r, d) => r + d, 0), e = 100;
  return i !== e ? (console.warn(`${t} component: The sum of values must equal ${e}. Current sum: ${i}`), !1) : !0;
}, T = ({
  comparisonLabel: o,
  leftValue: t,
  middleText: i = "DRAW",
  middleValue: e = 0,
  rightValue: r,
  tooltipText: d,
  ...g
}) => {
  if (!j([t, e, r]))
    return null;
  const _ = `${t}%`, h = `${e}%`, m = `${r}%`, p = e > 0, v = e > 0 && r <= 20;
  return /* @__PURE__ */ s(
    "div",
    {
      "aria-label": `${o} comparison bar with ${t}% on the left, ${e}% draw in the middle, and ${r}% on the right.`,
      className: a.comparisonContainer,
      "data-cxy-name": "comparison",
      role: "region",
      ...g,
      children: [
        /* @__PURE__ */ s("div", { className: a.valuesContainer, children: [
          /* @__PURE__ */ n("span", { className: a.value, "data-testid": "comparison-left", children: /* @__PURE__ */ s(l, { className: a.leftBadge, children: [
            t,
            "%"
          ] }) }),
          /* @__PURE__ */ s("div", { className: a.label, children: [
            o,
            " ",
            d && /* @__PURE__ */ n(B, { children: d })
          ] }),
          /* @__PURE__ */ n("span", { className: a.value, "data-testid": "comparison-right", children: /* @__PURE__ */ s(l, { className: a.rightBadge, children: [
            r,
            "%"
          ] }) })
        ] }),
        /* @__PURE__ */ s("div", { className: c(a.progressBarContainer, { [a.hasMiddleValue]: p }), children: [
          /* @__PURE__ */ n(
            "div",
            {
              className: `${a.progressBar} ${a.leftBar}`,
              "data-testid": "comparison-left-bar",
              style: { width: _ }
            }
          ),
          /* @__PURE__ */ n(
            "div",
            {
              className: a.separatorContainer,
              "data-testid": "comparison-middle-bar",
              style: {
                width: e ? `${e}%` : void 0
              },
              children: e > 0 && /* @__PURE__ */ s(l, { className: c(a.middleBadge, { [a.badgeRightAligned]: v }), children: [
                i,
                " ",
                h
              ] })
            }
          ),
          /* @__PURE__ */ n(
            "div",
            {
              className: `${a.progressBar} ${a.rightBar}`,
              "data-testid": "comparison-right-bar",
              style: { width: m }
            }
          )
        ] })
      ]
    }
  );
};
export {
  T as Comparison
};
